"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyShare = void 0;
const constants_1 = require("@dzambalaorg/constants");
exports.emptyShare = { payees: [constants_1.wallet], shares: [100] };
//# sourceMappingURL=empty.js.map